
import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import ResultsCard from '@/features/shipment/components/results/index.vue';
import DetailsFoldout from '@/features/shipment/components/results/DetailsFoldout.vue';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import DetailsFoldoutMixin from '@/features/common/mixins/detailsFoldoutMixin';
import { InProgress } from '../types';

@Component({
  components: {
    ResultsCard,
    DetailsFoldout,
  },
})
export default class Results extends Mixins(DetailsFoldoutMixin) {
  @Prop({ default: false }) isJustEstimate!: boolean;

  created(): void {
    eventBus.$on(eventNames.OPEN_ESTIMATE_RESULTS_DETAIL, this.openDetails);
    eventBus.$on(eventNames.HIDE_ESTIMATE_RESULTS_DETAIL, this.hideDetails);
  }

  // eslint-disable-next-line class-methods-use-this
  get shipmentSection(): HTMLElement {
    return document.querySelector('.shipment') as HTMLElement;
  }

  get isInProgressData(): number {
    return this.$store.getters.getIsInProgressData;
  }

  get inProgressData(): InProgress {
    return this.$store.getters.getInProgress;
  }
}
